import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ProductPrice from "../product/ProductPrice";
import { useSelector } from "react-redux";
// import CustomSlider from "../Common/CustomSlider";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { PERC_OFF_TEXT } from "../../utils/Constant";

// import Swiper core and required modules
import { Autoplay, Navigation, Pagination } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";

import { isMobile } from "react-device-detect";

function RecentlyViewedProducts({ settings }) {
  const navigation_status = isMobile? false:true;  
  const slide_per_view = isMobile?2:4;
  const slide_btn_space = isMobile?7:20;
  // if (!settings) {
  //   settings = {
  //     className: " product-right-slick",
  //     dots: false,
  //     infinite: false,
  //     speed: 500,
  //     slidesToShow: 4,
  //     slidesToScroll: 4,
  //     initialSlide: 0,
  //     cssEase: "linear",
  //     mobileFirst: true,
  //     responsive: [
  //       {
  //         breakpoint: 1024,
  //         settings: {
  //           slidesToShow: 4,
  //           slidesToScroll: 4,
  //           infinite: false,
  //           dots: false,
  //         },
  //       },
  //       {
  //         breakpoint: 600,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 3,
  //           initialSlide: 0,
  //         },
  //       },
  //       {
  //         breakpoint: 480,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //         },
  //       },
  //     ],
  //   };
  // }

  const [recentlyViewedProduct, setRecentlyViewedProduct] = useState([]);

  // Get Recently Viewed Products State
  const rvProducts = useSelector((state) => state.recentViewedProduct);

  useEffect(() => {
    setRecentlyViewedProduct(rvProducts?.products);
  }, [rvProducts]);

  return (
    <>
      {recentlyViewedProduct?.length > 4 && (
        <section className="recently-viewed spacer-xl">
          <div className="main-heading-center bg-light">
            <h3>Recently Viewed</h3>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-11 mx-auto">
                {/* <CustomSlider settings={settings}> */}
                <Swiper
                  slidesPerView={slide_per_view}
                  spaceBetween={slide_btn_space}
                  centeredSlides={false}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  // pagination={{
                  //   clickable: true,
                  // }}
                  navigation={navigation_status}
                  loop={true}
                  modules={[Autoplay, Pagination, Navigation]}
                  className="mySwiper"                
                >
                  {recentlyViewedProduct
                    ?.filter((item) => item && item.id_product)
                    ?.map((product, index) => {
                      return (
                        <SwiperSlide key={"mySwiperRecent" + index}>
                        <div
                          className="item"
                          key={product?.id_product + "_" + index}
                        >
                          <div
                            className={`product-box bg-white ${
                              product?.available_for_order === "0"
                                ? " sold-out"
                                : ""
                            }`}
                          >
                            <Link to={`/product/${product.url_path}`}>
                              <LazyLoadImage
                                alt={""}
                                effect="blur"
                                // src={product?.images?.at(0)?.src}
                                src={product?.images[0]?.src}
                                className="img-fluid mx-auto d-block"
                              />

                              {product?.available_for_order === "0" && (
                                <div className="sold-out-text text-center">
                                  {product?.sold_out_heading || "SOLD OUT"}
                                </div>
                              )}
                            </Link>

                            <div className="text text-center">
                              <h6 className="text-black text-capitalize">
                                <Link to={`/product/${product.url_path}`}>
                                  {product?.designer_name}
                                </Link>
                              </h6>
                              <ProductPrice
                                price={product.price}
                                show_price={
                                  product.show_price?.toString() === "1"
                                }
                                discount_price={product.discount_price}
                                discount_perc={product.discount_percentage}
                                show_discount_price={
                                  product.show_discount_price?.toString() ===
                                  "1"
                                }
                                show_discount_perc={false}
                                perc_text={PERC_OFF_TEXT}
                                page={"product"}
                                layout="3"
                              />
                            </div>
                          </div>
                        </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>  
                {/* </CustomSlider> */}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default RecentlyViewedProducts;
